<template>
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 38 38">
        <g transform="translate(-1300 -196)">
            <circle class="st0" cx="1319" cy="215" r="19" fill="#383935"/>
            <path class="st1" d="M1317.2,222.8h3.7c0,1-0.8,1.8-1.8,1.8S1317.2,223.8,1317.2,222.8 M1327.2,220.9v0.9h-16.4v-0.9l1.8-1.8v-5.5
                c0-2.8,1.8-5.3,4.6-6.1v-0.3c0-1,0.8-1.8,1.8-1.8s1.8,0.8,1.8,1.8v0.3c2.7,0.8,4.6,3.3,4.6,6.1v5.5L1327.2,220.9 M1323.6,213.6
                c0-2.6-2-4.6-4.6-4.6s-4.6,2-4.6,4.6v6.4h9.1V213.6z" fill="#A5D867"/>
        </g>
    </svg>
</template>

<script>
export default {
  name: 'NotificationsIcon'
}
</script>

<style scoped>
    svg {
        width:38px;
        height: 38px;
    }
</style>